import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Template} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {DataSource, IListItemState} from '@mintdata/mint-kit/api/models/List';
import {ContextMenu, IContextMenuItem, ToggleOn} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IStyles} from '@mintdata/mint-kit/impl/util/Styles';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./TemplatesCategorySelector.less');
const cx = classnames.bind(styles);

export enum TemplatesCategories
{
    All = 'All',
}

interface Props
{
}

interface State
{
    isOpened:boolean;
}

interface ITemplatesSortMenuItem extends IContextMenuItem
{
    spaceId?:number;
}

@observer
export class TemplatesCategorySelector extends React.Component<Props, State>
{
    @computed
    private get _menuItems():Array<ITemplatesSortMenuItem>
    {
        const {allTemplates} = controllers.ui.mainPage;

        const menuItems:Array<ITemplatesSortMenuItem> = [];
        const allCategories:Array<string> = [];

        if( !allTemplates ) return menuItems;

        allTemplates.forEach((template:Template) =>
        {
            const {categories} = template;
            if( categories && categories.length )
            {
                categories.forEach((category:string) =>
                {
                    if( allCategories.indexOf(category) === -1 )
                    {
                        allCategories.push(category);
                        menuItems.push({label: category});
                    }
                });
            }
        });

        menuItems.unshift({
            isSeparator: true,
        });

        menuItems.unshift({
            label: TemplatesCategories.All,
        });

        return menuItems;
    }

    public constructor(props:any)
    {
        super(props);

        this.state = {
            isOpened: false
        };
    }

    private _onShow = () => this.setState({isOpened: true});
    private _onHide = () =>
    {
        this.setState({isOpened: false});
    };

    @bind
    private _menuProvider():DataSource<ITemplatesSortMenuItem>
    {
        const {selectedTemplatesCategory} = rootState.ui.mainPage;

        return this._menuItems.map((item:ITemplatesSortMenuItem) =>
        {
            if( item.isSeparator ) return item;

            const isSelected = item.label === selectedTemplatesCategory;

            return {
                ...item,
                isSelected,
                handler: () => this._selectMenuItem(item)
            } as ITemplatesSortMenuItem;
        });
    }

    @action
    private _selectMenuItem(item:ITemplatesSortMenuItem)
    {
        rootState.ui.mainPage.selectedTemplatesCategory = item.label as string;
    }

    @bind
    private _renderSheetsMenuItem({label, isSeparator}:ITemplatesSortMenuItem,
                                  {isSelected}:IListItemState,
                                  {menuItem, separator}:IStyles):JSX.Element
    {
        if( isSeparator ) return (
            <div className={cx(separator)} />
        );

        return (
            <div className={cx(styles.menuItem, menuItem)}>

                <div className={styles.menuItemIcon}>
                    {
                        isSelected &&
                        <MDIcon
                            name={MDIcons.common.Checkmark}
                            size={MDIconSize.medium16}
                            className={styles.icon}
                        />
                    }
                </div>

                <div className={styles.menuItemLabel}>
                    {label}
                </div>

            </div>
        );
    }

    public render():JSX.Element
    {
        const togglerId = 'templatesCategorySelector';

        const {selectedTemplatesCategory} = rootState.ui.mainPage;

        const {isOpened} = this.state;

        return (
            <div className={cx(styles.base)} id={togglerId}>
                <ContextMenu
                    toggleOn={[ToggleOn.CLICK]}
                    togglersIds={[togglerId]}
                    popupAnchor={PopupAnchor.LeftTop}
                    sourceAnchor={SourceAnchor.LeftBottom}
                    popupClassName={styles.menuPopup}
                    dataSource={this._menuProvider}
                    itemRenderer={this._renderSheetsMenuItem}
                    onShow={this._onShow}
                    onHide={this._onHide}
                    contentClassName={styles.popupContent}
                >
                    <div className={cx(styles.handler, {isOpened})}>
                        <div className={cx(styles.handlerText)}>
                            {selectedTemplatesCategory}
                        </div>
                        <MDIcon
                            className={cx(styles.menuIcon, {isOpened})}
                            name={MDIcons.common.ChevronRight}
                        />
                    </div>
                </ContextMenu>
            </div>
        );
    }
}
